export enum DataType {
  NUMBER = 'number',
  DATE = 'date',
  STRING = 'string',
  BOOLEAN = 'boolean'
}